"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _components = require("../../../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var VideoControl = function VideoControl(_ref) {
  var iconType = _ref.iconType,
    label = _ref.label,
    isMaximized = _ref.isMaximized,
    onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('--tag-video-control h-full', 'flex flex-col gap-y-[8px] items-center justify-center', 'text-white', isMaximized ? 'w-[120px]' : 'w-[104px]')
  }, /*#__PURE__*/_react.default.createElement(_components.IconButton, {
    icon: iconType,
    size: "large",
    onClick: onClick,
    onTouchStart: onClick
  }), label && /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-caption-regular whitespace-nowrap"
  }, label));
};
var _default = VideoControl;
exports.default = _default;